import clsx, { ClassValue } from 'clsx';
import { twMerge } from 'tw-merge';

/**
 * Combines multiple class values into a single string while merging Tailwind
 * classes where classes specified later overwrite preceding classes.
 */
export function cn(...classnames: ClassValue[]) {
  return twMerge(clsx(classnames));
}
